import React, { useContext } from 'react';
import { IconButton, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import OrdersContext from '../../Context/Orders/OrdersContext';
import NewOrderForm from './NewOrderForm';

export default function NewOrderDialog() {
	const { openNewOrderDialog, toogleNewOrderDialog } =
		useContext(OrdersContext);

	return (
		<div>
			<Dialog
				open={openNewOrderDialog}
				onClose={() => toogleNewOrderDialog('close')}
			>
				<DialogTitle
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					Nuevo pedido
					<IconButton
						aria-label='close-privacy-policy'
						onClick={() => toogleNewOrderDialog('close')}
					>
						<Close />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<NewOrderForm />
				</DialogContent>
			</Dialog>
		</div>
	);
}
